import { Link } from 'react-router-dom'
import { Result, Button } from '@arco-design/web-react'
import { useTranslation } from 'react-i18next'

export default function Forbidden() {
  const { t } = useTranslation()

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--console-page-bg)]">
      <Result
        status="403"
        title="403"
        subTitle={t('common.forbidden')}
        extra={
          <Link to="/console">
            <Button type="primary">{t('common.backConsole')}</Button>
          </Link>
        }
      />
    </div>
  )
}
